export default __webpack_public_path__ + "static/media/contextual-chocolate@2x.42b6881a.png";